import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { TranslateService } from "../../../../common/variables/translate-service";

@Component({
  selector: 'sen-app-mount-rafter',
  templateUrl: './mount-rafter.component.html',
  styleUrls: ['./mount-rafter.component.scss']
})
export class MountRafterComponent implements OnInit {
  @Input() hbRoofHook: boolean;
  @Output() emitbSuccess = new EventEmitter;
  constructor(public translate: TranslateService) { }

  ngOnInit(): void { }

  navNext() { }

  navPrev() { }

  setbSuccess(event: boolean) {
    this.emitbSuccess.emit(event);
  }
}
